import {datetime, sorting} from "@atttomyx/shared-utils";

export const sortByDue = (a, b) => sorting.sortByFields(a, b, "dueOn", "dueAt");
export const sortByDueDesc = (a, b) => sorting.sortByFieldsDesc(a, b, "dueOn", "dueAt");

export const isIncomplete = (task) => !task.completed;

export const isDue = (task) => isIncomplete(task)
    && (task.dueOn === datetime.today() || datetime.isPastDate(task.dueOn));
